(function () {
    'use strict';

    angular
        .module('salesflare.components.emailDisplay', [])
        .component('sfEmailDisplay', {
            controller,
            controllerAs: 'vm',
            templateUrl: 'app-ajs/components/emaildisplay/emaildisplay.html',
            bindings: {
                content: '<'
            }
        });

    function controller($rootScope, $sce, $element, $timeout, model, themeService) {

        const vm = this;
        let iframeObserver;

        vm.$onInit = function () {

            setIframeContent();
        };

        vm.$onDestroy = function () {

            if (iframeObserver) {
                iframeObserver.disconnect();
            }
        };

        vm.$onChanges = function (changes) {

            if (changes.content && changes.content.currentValue) {
                setIframeContent();
            }
        };

        // Srcdoc isn't supported in IE and older versions of Edge (below version 18) so we insert the content into the iframe via .open() and .write()
        // see https://developer.mozilla.org/en-US/docs/Web/API/Document/open
        // polyfilling srcdoc wasn't an option as it requires loading JS which didn't work with our iframe sandbox implementation.
        function setIframeContent() {

            const iframe = $element.children('iframe');
            const doc = iframe[0].contentWindow.document;
            doc.open();
            doc.write(vm.getIframeContent());
            doc.close();

            // Disconnecting the observer is needed for IE/Edge, throws Permission Denied errors otherwise
            if (iframeObserver) {
                iframeObserver.disconnect();
            }

            iframeObserver = new ResizeObserver(function (entries) {

                // Set the height on the next tick to prevent this from triggering another observer event in the same tick
                // This was causing infinite loops https://github.com/Salesflare/Client/issues/1764
                $timeout(function () {

                    return iframe.height(entries[0].contentRect.height);
                });
            });

            iframeObserver.observe(iframe[0].contentDocument.documentElement);
        }

        vm.getIframeContent = function () {
            let htmlClass = '';
            let content = vm.content;

            const theme = themeService.get();

            if (theme === 'dark') {
                htmlClass = ' class="dark-mode"';

                const emojiRegex = /([\u{1F300}-\u{1F5FF}\u{1F900}-\u{1F9FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E6}-\u{1F1FF}\u{1F191}-\u{1F251}\u{1F004}\u{1F0CF}\u{1F170}-\u{1F171}\u{1F17E}-\u{1F17F}\u{1F18E}\u{3030}\u{2B50}\u{2B55}\u{2934}-\u{2935}\u{2B05}-\u{2B07}\u{2B1B}-\u{2B1C}\u{3297}\u{3299}\u{303D}\u{00A9}\u{00AE}\u{2122}\u{23F3}\u{24C2}\u{23E9}-\u{23EF}\u{25B6}\u{23F8}-\u{23FA}])/gu;
                content = content.replace(emojiRegex, '<span class="sf-emoji">$1</span>');
            }

            // Content = stripPrefersDarkMediaQueries(content);

            // Doctype is needed see https://github.com/Foundry376/Mailspring/blob/110c44359875edf2ce19e9e9eb89610aa963174a/app/internal_packages/message-list/lib/email-frame.tsx#L81-L85
            // Add some custom styles to make it fit inside Salesflare. This means same font, bg color, font size, scrollbars, ...
            // We set overflow-y to hidden because we are going to show emails in full height but sometimes the vertical scrollbar messes with the full height calculation
            return $sce.trustAsHtml(`
                <!DOCTYPE html>
                <html ${htmlClass}>
                <head>
                    <base target="_blank" ></base>
                    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;500;600;700;800;900">
                    <style type="text/css">
                        html, body {
                            margin: 0;
                            background-color: white;
                            font-family: 'Source Sans 3', sans-serif;
                            color: rgba(0, 0, 0, 0.87);
                            font-size: 14px;
                            overflow-y: hidden;
                            -webkit-text-size-adjust: 100%;
                            -ms-text-size-adjust: 100%;
                            -moz-osx-font-smoothing: grayscale;
                            -webkit-font-smoothing: antialiased;
                        }

                        html.dark-mode {
                            filter: invert(100%) hue-rotate(180deg);
                        }

                        html.dark-mode, html.dark-mode body {
                            background-color: #dde1eb;
                            color: #040404;
                        }

                        html.dark-mode img,
                        html.dark-mode [style*="background-image"]:not([style*="background-image: none"]):not([style*="background-image:none"]),
                        html.dark-mode video,
                        html.dark-mode .sf-emoji {
                            filter: invert(100%) hue-rotate(180deg);
                        }
                    
                        html.dark-mode pre {
                            filter: invert(6%);
                        }
                    
                        html.dark-mode li::marker {
                            color: #666;
                        }

                        ::-webkit-scrollbar {
                            width: 6px;
                            height: 6px;
                            background-color: transparent;
                        }
                        
                        ::-webkit-scrollbar:hover {
                            background-color: #eee;
                        }
                        
                        ::-webkit-resizer {
                            -webkit-border-radius: 4px;
                            background-color: #666;
                        }
                        
                        ::-webkit-scrollbar-thumb {
                            min-height: 0.8em;
                            min-width: 0.8em;
                            background-color: rgba(0, 0, 0, 0.2);
                            box-shadow: inset 1px 1px 0 rgba(0, 0, 0, 0.1), inset -1px -1px 0 rgba(0, 0, 0, 0.07);
                        }
                        
                        ::-webkit-scrollbar-thumb:hover {
                            background-color: #bbb;
                        }
                        
                        ::-webkit-scrollbar-thumb:active {
                            background-color: #888;
                        }
                        
                    </style>
                </head>
                ${content}
                </html>
            `);
        };

        // eslint-disable-next-line no-unused-vars
        function stripPrefersDarkMediaQueries(html) {
            if (!html || !html.includes('@media') || !html.toLowerCase().includes('prefers-color-scheme')) {
                return html;
            }

            return html.replace(/(<style\b[^>]*>)([\s\S]*?)(<\/style>)/gi, function (match, styleStartTag, cssContent, styleEndTag) {
                return styleStartTag + stripPrefersDarkMediaQueriesFromCss(cssContent) + styleEndTag;
            });
        }

        function stripPrefersDarkMediaQueriesFromCss(css) {
            if (!css) {
                return css;
            }

            const darkMediaRegex = /@media\s*\(\s*prefers-color-scheme\s*:\s*dark\s*\)\s*\{/gi;
            let result = '';
            let cursor = 0;
            let darkMediaMatch;

            while ((darkMediaMatch = darkMediaRegex.exec(css)) !== null) {
                const blockStart = darkMediaMatch.index;
                const openBraceIndex = darkMediaRegex.lastIndex - 1;
                const blockEnd = findMatchingBlockEnd(css, openBraceIndex);

                result += css.slice(cursor, blockStart);

                if (blockEnd === -1) {
                    // Malformed CSS block, keep the remainder as-is to avoid breaking styles.
                    return result + css.slice(blockStart);
                }

                cursor = blockEnd + 1;
                darkMediaRegex.lastIndex = cursor;
            }

            return result + css.slice(cursor);
        }

        function findMatchingBlockEnd(css, openBraceIndex) {
            let depth = 0;

            for (let i = openBraceIndex; i < css.length; ++i) {
                if (css[i] === '{') {
                    depth++;
                }
                else if (css[i] === '}') {
                    depth--;

                    if (depth === 0) {
                        return i;
                    }
                }
            }

            return -1;
        }
    }
})();
